import { RequestConstants } from "../../../../core/request/RequestConstants";
import { WebRequest } from "../../../../core/request/WebRequest";
import { GetSettingsResponseData } from "../response/data/GetSettingsResponseData";
/**
 * GetSettingsRequest.ts
 */
export class GetSettingsRequest extends WebRequest {
    constructor(params) {
        super(GetSettingsRequest.URL, params);
    }
    getMethod() {
        return RequestConstants.POST;
    }
    getDataClass() {
        return GetSettingsResponseData;
    }
}
GetSettingsRequest.URL = "/responsible-gaming/api/getSettings";
//# sourceMappingURL=GetSettingsRequest.js.map